module.exports = __webpack_public_path__ + "static/media/R&R_-set-2.847d203f.jpg";